/* eslint-disable */
import axios from '../index'

const getPersonalDevCard = () => {
  return axios.get('pages/personalDevCard')
}
const getBussinesCunsultingCard = () => {
  return axios.get('pages/bussinesCunsultingCard')
}
const getJoinOurFamilyCard = () => {
  return axios.get('pages/joinOurFamilyCard')
}
const getSubscribeMagazine = () => {
  return axios.get('pages/subscribeMagazine')
}
const getAbout = () => {
  return axios.get('pages/about')
}
const getError = () => {
  return axios.get('pages/error')
}
const getSuccess = () => {
  return axios.get('pages/success')
}
const getJoinOurFamilyPage = () => {
  return axios.get('pages/joinOurFamilyPage')
}
const getJoinOurFamilyHire = () => {
  return axios.get('pages/joinOurFamilyHire')
}
const getJoinOurFamilyWork = () => {
  return axios.get('pages/joinOurFamilyWork')
}
const getMagazinePage = () => {
  return axios.get('pages/magazinePage')
}
const getMagazinePageInfo = () => {
  return axios.get('pages/magazinePageInfo')
}
const getPersonalDevPage = () => {
  return axios.get('pages/personalDevPage')
}
const getBussinesCunsultingPage = () => {
  return axios.get('pages/bussinesCunsultingPage')
}
const getGetService = () => {
  return axios.get('pages/getService')
}
const getRequest = () => {
  return axios.get('pages/request')
}

const api = {
  getGetService,
  getPersonalDevCard,
  getBussinesCunsultingCard,
  getJoinOurFamilyCard,
  getSubscribeMagazine,
  getAbout,
  getError,
  getSuccess,
  getJoinOurFamilyPage,
  getJoinOurFamilyHire,
  getJoinOurFamilyWork,
  getMagazinePage,
  getMagazinePageInfo,
  getPersonalDevPage,
  getBussinesCunsultingPage,
  getRequest,
}


export default api;